
export default class TrackString {
    static createDialogChoiceParams(dialogId, situation, choice, contentId) {
        return {
            dialog_id: dialogId,
            dialog_situation: situation,
            dialog_choice: choice,
            dialog_choice_content_id: contentId
        };
    }

    static createDialogParams(dialogId) {
        return {
            dialog_id: dialogId
        };
    }

    static createScenarioEndParams({ duration }) {
        return {
            duration
        };
    }

    static createConversationOutcomeParams({ outcomeId }) {
        return {
            outcome_id: outcomeId,
        };
    }

    static createConversationPhaseChangedParams({ conversationId, phaseId, previousPhaseId, turnIndex }) {
        return {
            conversation_id: conversationId,
            phase_id: phaseId,
            previous_phase_id: previousPhaseId,
            turn_index: turnIndex,
        };
    }

    static createHintRequestParams({ conversationId, phaseId, turnIndex }) {
        return {
            conversation_id: conversationId,
            phase_id: phaseId,
            turn_index: turnIndex,
        };
    }

    static createReflectionPlayerTurnParams({ reflectionId, turnIndex, numberOfInputCharacters }) {
        return {
            reflection_id: reflectionId,
            turn_index: turnIndex,
            number_of_input_characters: numberOfInputCharacters,
        };
    }
}

// NB: Google Analytics naming convention for Events and Parameters is Snake Case 
TrackString.PERSISTENT_ENVIRONMENT = "environment";
TrackString.PERSISTENT_BUILD_ID = "build";
TrackString.ANALYTICS_VERSION = "analytics_version";
TrackString.CONTENT_VERSION = "content_version";
TrackString.GAME_SESSION_ID = "game_session_id";

TrackString.EVENT_SESSION_START = "game_session_start";
TrackString.EVENT_SESSION_END = "game_session_end";

// NGT
TrackString.PERSISTENT_STORY_ID = "story_id";

TrackString.EVENT_SCENARIO_START = "scenario_start";
TrackString.EVENT_SCENARIO_END = "scenario_end";

TrackString.EVENT_DIALOG_START = "dialog_start";
TrackString.EVENT_DIALOG_END = "dialog_end";
TrackString.EVENT_DIALOG_CHOICE = "dialog_choice";

TrackString.EVENT_KEY_MOMENT_CHOICE = "key_moment_choice";

TrackString.EVENT_DECISION_DIALOG_START = "decision_start";
TrackString.EVENT_DECISION_DIALOG_END = "decision_end";
TrackString.EVENT_DECISION_CHOICE = "decision_choice";

// Game specific
TrackString.EVENT_GAME_START = "game_start";
TrackString.EVENT_GAME_END = "game_end";

TrackString.EVENT_CONVERSATION_OUTCOME = "conversation_outcome";
TrackString.EVENT_CONVERSATION_PHASE_ENTER = "conversation_phase_enter";

TrackString.EVENT_HINT_REQUEST = "hint_request";

TrackString.EVENT_REFLECTION_PLAYER_TURN = "reflection_player_turn";